import React from 'react';
import { Row, Col } from 'antd';
import { DollarOutlined, ShoppingCartOutlined, CodeSandboxOutlined, LineChartOutlined } from '@ant-design/icons';
import { StatsCard } from '../../../UI/Card/StatsCard';

interface AnalysisStatsProps {
    summary: {
        totalSales: number;
        totalUnits: number;
        totalOrders: number;
        aov: number;
    };
}

export const AnalysisStats: React.FC<AnalysisStatsProps> = ({ summary }) => {
    return (
        <Row gutter={16} style={{ marginBottom: 16 }}>
            <Col span={6}>
                <StatsCard
                    title="总销售额"
                    value={`$${summary.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    icon={<DollarOutlined />}
                    color="blue"
                />
            </Col>
            <Col span={6}>
                <StatsCard
                    title="总订单数"
                    value={summary.totalOrders.toLocaleString()}
                    icon={<ShoppingCartOutlined />}
                    color="purple"
                />
            </Col>
            <Col span={6}>
                <StatsCard
                    title="总销量 (Units)"
                    value={summary.totalUnits.toLocaleString()}
                    icon={<CodeSandboxOutlined />}
                    color="orange"
                />
            </Col>
            <Col span={6}>
                <StatsCard
                    title="平均客单价 (AOV)"
                    value={`$${summary.aov.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                    icon={<LineChartOutlined />}
                    color="green"
                />
            </Col>
        </Row>
    );
};
